import React from 'react';
import SolutionRequestEstimateSolutionContainer from 'containers/SolutionRequestEstimateSolutionContainer/SolutionRequestEstimateSolutionContainer';

export default function SolutionRequestEstimateSolutionPage() {
    return (
        <SolutionRequestEstimateSolutionContainer />
    )
}
